// src/pricing/priceEngine.js
export const round2 = n => Math.round((n + Number.EPSILON) * 100) / 100;
const num = v => (typeof v === "string" ? parseFloat(v.replace(",", ".")) : Number(v || 0));

export function lineTotal(it) {
  const byArea = num(it.area_m2) * num(it.price_per_m2);
  const byEdge = num(it.edge_length_m) * num(it.edge_price_per_m);
  const byUnit = num(it.quantity) * num(it.net_unit_price ?? it.unit_price);
  return round2(byArea + byEdge + byUnit);
}

function recomputeSection(section = {}) {
  const items = (section.items || []).map(it => ({ ...it, total_cost: lineTotal(it) }));
  const subtotal = round2(items.reduce((s, it) => s + it.total_cost, 0));
  const discount_pct = num(section.discount_pct);
  const discount_value = round2(subtotal * discount_pct);
  const total = round2(subtotal - discount_value);
  return { ...section, items, subtotal, discount_pct, discount_value, total };
}

export function recomputeAll(q = {}) {
  const euro_rate = num(q.euro_rate) || num(q.euroRate) || 117;
  const materials = recomputeSection(q.materials || {});
  const equipment = recomputeSection(q.equipment || {});
  const services  = recomputeSection(q.services  || {});
  const grand_subtotal = round2(materials.subtotal + equipment.subtotal + services.subtotal);
  const grand_discount = round2(materials.discount_value + equipment.discount_value + services.discount_value);
  const grand_total    = round2(materials.total + equipment.total + services.total);
  return {
    code: q.code || "",
    currency: (q.currency || "RSD").toUpperCase(),
    euro_rate,
    discounts: q.discounts || { materials_pct: 0, equipment_pct: 0, services_pct: 0 },
    materials, equipment, services,
    grand_subtotal, grand_discount, grand_total,
  };
}

export function rsdToEur(rsd, rate) {
  const r = num(rate) || 117;
  return round2(num(rsd) / r);
}

// ▼ stiže iz Viewera: setuj pravu cenu i izračunaj sve opet
export function setMaterialPriceByThickness(q, sceneMaterial, guessThickness, priceRsd) {
  const next = structuredClone(q);
  const name = String(sceneMaterial || "").toLowerCase();

  const idx = next.materials.items.findIndex(
    it => String(it.name || "").toLowerCase() === name
  );
  if (idx === -1) return q;

  const row = { ...next.materials.items[idx] };

  const applyIfChanged = (key, val) => {
    if (Math.abs(num(row[key]) - num(val)) < 0.01) return false;
    row[key] = round2(num(val));
    return true;
  };

  let changed = false;
  if (num(row.edge_length_m) > 0 && num(row.area_m2) === 0) {
    // kanta – cena je po metru
    changed = applyIfChanged("edge_price_per_m", priceRsd);
  } else if (num(row.area_m2) > 0) {
    // ploča – cena je po m²
    changed = applyIfChanged("price_per_m2", priceRsd);
  } else {
    // komadna stavka
    changed = applyIfChanged("net_unit_price", priceRsd);
  }

  if (!changed) return q;

  row.total_cost = lineTotal(row);
  next.materials.items[idx] = row;

  return recomputeAll(next);
}

export function setMaterialRowPrice(q, idx, priceRsd) {
  const next = structuredClone(q);
  if (!next.materials?.items?.[idx]) return q;
  next.materials.items[idx] = {
    ...next.materials.items[idx],
    price_per_m2: round2(num(priceRsd)),
  };
  return recomputeAll(next);
}

export function setDiscounts(q, { materials_pct, equipment_pct, services_pct }) {
  const next = structuredClone(q);
  next.materials.discount_pct = num(materials_pct ?? next.materials.discount_pct);
  next.equipment.discount_pct = num(equipment_pct ?? next.equipment.discount_pct);
  next.services.discount_pct  = num(services_pct  ?? next.services.discount_pct);
  return recomputeAll(next);
}
